import { useState } from 'react';
import { ScanLine, Search } from 'lucide-react';
import { Input } from '../../components/ui/input';
import { Button } from '../../components/ui/button';
import BarcodeScanner from './BarcodeScanner';

/** Camera scan button + manual number/name entry, sharing one submit handler. */
export default function ScanOrType({ onCode, placeholder = 'Type barcode or product name', continuous = false, testId = 'staff-app-scan' }) {
  const [value, setValue] = useState('');
  const [scanning, setScanning] = useState(false);

  const submit = (e) => {
    e.preventDefault();
    const code = value.trim();
    if (!code) return;
    onCode(code);
    setValue('');
  };

  return (
    <>
      <form onSubmit={submit} className="flex gap-2">
        <Button type="button" onClick={() => setScanning(true)} className="h-11 px-3 shrink-0" data-testid={`${testId}-camera`}>
          <ScanLine className="w-5 h-5 mr-1.5" /> Scan
        </Button>
        <Input value={value} onChange={(e) => setValue(e.target.value)} placeholder={placeholder}
          inputMode="search" className="h-11" data-testid={`${testId}-input`} />
        <Button type="submit" variant="outline" size="icon" className="h-11 w-11 shrink-0" aria-label="Search" data-testid={`${testId}-submit`}>
          <Search className="w-4 h-4" />
        </Button>
      </form>
      {scanning && (
        <BarcodeScanner continuous={continuous} onClose={() => setScanning(false)}
          onDetected={(code) => { if (!continuous) setScanning(false); onCode(code); }} />
      )}
    </>
  );
}
